module.exports = __webpack_public_path__ + "img/list-tree.0c25cc68.svg";